import {  makeStyles, Text, tokens } from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles({
  flex: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    maxWidth: "700px",
    margin: `${tokens.spacingHorizontalXXXL} 0px`,
    color: tokens.colorNeutralForeground1,
  }
});

export const AppListPageHeader: React.FC = () => {
  const classes = useStyles();
  const intl = useIntl();

  const title = intl.formatMessage({ defaultMessage: 'Apps', description: 'App List title' });
  const subtitle = intl.formatMessage({
    defaultMessage: 'Select an app to see more information or update its configurations.',
    description: 'description for App List page',
  });
  return (
    <div className={classes.flex}>
      <Text size={500} weight="semibold">
        {title}
      </Text>
      <Text size={200}>
        {subtitle}
      </Text>
    </div>
  );
}
